/* h26-cart-line: the pre-order line above UpCart's checkout button. Config and rules: snippets/h26-cart-line.liquid.
   The note text arrives HTML-escaped from Liquid, so innerHTML only decodes entities. */
(function () {
  var C = window.OO_H26_CARTLINE;
  if (!C || window.__ooH26CartLine) return;
  window.__ooH26CartLine = true;
  var CLS = 'oo-h26-cartline', last = [], seen = false, timer = null;
  function past() { if (!C.cutoff) return false; var t = Date.parse(C.cutoff); return !isNaN(t) && Date.now() > t; }
  function isPre(items) {
    var suf = (C.suffix || '').toUpperCase();
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i] || {}, sku = String(it.sku || '').toUpperCase();
      if (suf && sku && sku.slice(-suf.length) === suf) return true;
      if (it.handle && (C.sets || []).indexOf(it.handle) > -1) return true;
    }
    return false;
  }
  function root() { var h = document.getElementById('upCart'); return h && h.shadowRoot; }
  // Country hides, flags from Liquid. Runbook 18f: no 'Upgrade to Subscription' where subscribe is off (C.subHide).
  // Runbook 21: no free-shipping bar where checkout has no free shipping, Canada and the Gulf (C.rewHide).
  function hideIn(r, on, id, css) {
    if (!on || r.getElementById(id)) return;
    var st = document.createElement('style'); st.id = id; st.textContent = css;
    r.appendChild(st);
  }
  function subHide(r) {
    hideIn(r, C.subHide, 'oo-h26-subhide', '.upcart-subscription-upgrade-section{display:none!important}');
    hideIn(r, C.rewHide, 'oo-h26-rewhide', '.upcart-rewards,.upcart-rewards-skeleton,.upcart-public-rewards{display:none!important}');
  }
  function render() {
    var r = root(); if (!r) return;
    subHide(r);
    if (!C.note) return;
    var old = r.querySelector('.' + CLS), anchor = r.querySelector('.upcart-checkout-button-container');
    if (!isPre(last) || past() || !anchor) { if (old) old.remove(); return; }
    if (old && old.nextElementSibling === anchor) return;
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = CLS;
    p.setAttribute('data-asset-id', 'h26-cart-line');
    p.setAttribute('data-placement', 'upcart-drawer');
    p.setAttribute('style', 'margin:0 0 10px;padding:8px 10px;font-size:13px;line-height:1.45;text-align:center;background:#f3f1e8;color:#34362c;border-radius:4px');
    p.innerHTML = C.note;
    anchor.parentNode.insertBefore(p, anchor);
    if (!seen) { seen = true; try { if (window.OOH26 && window.OOH26.track) window.OOH26.track('cart_note_view', {}, p); } catch (e) {} }
  }
  function soon() { clearTimeout(timer); timer = setTimeout(render, 80); }
  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { last = (c && c.items) || []; render(); }).catch(function () {});
  }
  ['cart-opened', 'cart-updated', 'cart-loaded', 'added-to-cart', 'item-removed'].forEach(function (n) {
    window.addEventListener('aftersell-upcart:public-events:' + n, function () { setTimeout(refresh, 120); });
  });
  // UpCart re-renders its footer; put the line back when it does (no loop: render() returns once it sits before the button)
  var tries = 0;
  (function watch() {
    var r = root();
    if (r && window.MutationObserver) { new MutationObserver(soon).observe(r, { childList: true, subtree: true }); return; }
    if (++tries < 40) setTimeout(watch, 500);
  })();
  refresh();
})();
